export const ACCESSES = {
    showLateOrdersNotify: 'showLateOrdersNotify',
};

export default {
    methods: {
        checkAccess: function(access) {
            // Проверяем есть ли доступ
            return this.$store.getters.accesses.findIndex(item => item === access) >= 0;
        },
        checkMultipleAccess: function(accesses) {
            if (!accesses) {
                return true;
            }

            let show = false;
            accesses.forEach(access => {
                if (this.checkAccess(access)) {
                    show = true;
                    return true;
                }
            });

            return show;
        },
        checkAccessPage: function(accesses) {
            if (this.checkMultipleAccess(accesses)) {
                return;
            }

            this.$root.$emit('pageNotFound', true);
        },
        clearAccess: function() {
            // Очищаем список доступов
            return this.$store.dispatch('clearAccess');
        },
    },
};